import type { ReactNode } from "react";
import { Spinner } from "../spinner";

interface PageProps {
  title: ReactNode | string;
  description?: ReactNode | string;
  actions?: ReactNode;
  children?: ReactNode;
  loading?: boolean;
  loadingComponent?: ReactNode;
  "data-testid"?: string;
}

export function Page({
  title,
  description,
  actions,
  children,
  loading = false,
  loadingComponent,
  "data-testid": dataTestId,
}: PageProps) {
  const isLoading = loadingComponent || loading;

  return (
    <div data-testid={dataTestId} className="h-full min-h-0 flex flex-col">
      <div className="flex-shrink-0 bg-white border-b border-slate-200">
        <div className="w-[70%] mx-auto py-4 flex items-center justify-between">
          <div>
            <h2 className="text-xl font-semibold text-slate-800">{title}</h2>
            {description && (
              <p className="mt-1 text-sm text-slate-500">{description}</p>
            )}
          </div>
          {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
      </div>
      {isLoading ? (
        <div className="flex-1 flex items-center justify-center">
          {loadingComponent || <Spinner />}
        </div>
      ) : (
        <div className="flex-1 overflow-y-auto">
          <div className="w-[70%] mx-auto py-6">{children}</div>
        </div>
      )}
    </div>
  );
}
